<template>
  <div class="mainContainer">
  </div>
</template>

<script>
export default {
  name: 'mainContainer',
  data () {
    return {
    }
  },
  created () {
    if (this.$store.getters.getAccessToken) {
      this.$router.push('home')
    }
    else{
      this.$router.push('splashScreen')

  }
}
}
</script>
